<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-navigation-drawer
      app
      class="crm-left-bar-background"
      clipped
      mini-variant
      mini-variant-width="100"
      permanent
    >
      <v-container>
        <v-row no-gutters class="mt-12">
          <v-col>
            <div class="text-center ml-2">
              <!--              {{ $store.state.app.available_applications[1].text }}-->
            </div>
          </v-col>
        </v-row>

        <div class="outline pr-1 pl-1 pb-1">
          <div class="crm-left-bar-menu caption">
            RFI
          </div>
          <v-btn
            x-small
            @click="$store.state.crmData.active_tab = 0"
            width="100%"
            class="crm-left-bar-item"
            >Dashboard</v-btn
          >
          <v-btn
            x-small
            @click="$store.state.crmData.active_process_tab = 0"
            width="100%"
            class="crm-left-bar-item"
            >New RFI</v-btn
          >
        </div>

        <div class="outline pr-1 pl-1 pb-1">
          <div class="crm-left-bar-menu mt-6 caption">
            Admin
          </div>
          <v-btn
            x-small
            @click="$store.state.crmData.active_tab = 1"
            width="100%"
            class="crm-left-bar-item"
            >Companies</v-btn
          >

          <v-btn
            x-small
            @click="$store.state.crmData.active_tab = 3"
            width="100%"
            class="crm-left-bar-item"
            >Tags</v-btn
          >
          <v-btn
            x-small
            @click="$store.state.crmData.active_tab = 2"
            width="100%"
            class="crm-left-bar-item"
            >Contacts</v-btn
          >
        </div>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'crm-left-sideBar',

  computed: {},

  data: () => ({}),

  methods: {}, //methods
};
</script>

<!--<style scoped></style>-->
